$(document).ready(function () {
    function updateVariantId() {
        $('.quantity-break').each(function () {
            var inputItem = $(this).find('[name="mrk-quantity"]');
            if ($(inputItem).is(':checked')) {
                $(this).find('.quantity-break__selector-item').each(function () {
                    // AHPK product picker manages its own data-selected-id — don't let the
                    // generic matcher wipe it (it has no .mrk-option-item / <select>).
                    if ($(this).hasClass('ahpk-selector')) return;
                    var variantId = null;
                    var selectedOptions = [];
                    var _this = $(this);
                    var options = $(this).find('select').val();
                    $(this).find('select').each(function () {
                        selectedOptions.push($(this).val());
                    });
                    $(this).find('.mrk-option-item:checked').each(function () {
                        selectedOptions.push($(this).val());
                    });
                    // Fetch variants from the JSON script tag within the quantity-breaks element
                    var variants = JSON.parse($(this).parents('mrk-bundle').find('script[type="application/json"]').html());
                    console.log(selectedOptions, variants);
                    variants.forEach(function (variant) {
                        var options = variant.options;
                        if (JSON.stringify(options) === JSON.stringify(selectedOptions)) {
                            variantId = variant.id;
                            // var image_src = variant.featured_media.preview_image?.src.split('files/')[1].split('?')[0];
                            if($(_this).find(`[mrk-id="${window.selected_select}"]`).length){
                              $(`[mrk-thumbnail="${variant.featured_media.id}"]`).click();
                              if (window.matchMedia('(max-width: 767px)').matches) {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                            }
                            if(variant.available){
                              $(this).find('.mrk-error').html('');
                            }else{
                              $(this).find('.mrk-error').html(`${variant.title} is unavailable!`);
                            }
                        }
                    });
                    if(variantId == null){
                      $(this).parents('.mrk-bundles__bar-variant').find('.mrk-error').html(`${selectedOptions.join(', ')} is unavailable!`);
                      
                    }else{
                      $(this).parents('.mrk-bundles__bar-variant').find('.mrk-error').html('');
                    }
                    $(this).attr('data-selected-id', variantId);

                });
            }
        });
    }
    function createHiddenSubscription(index){
      var variantId = $('.mrk-addon-id:checked').val();
      var quantity = 1;
      var subscription = $('.mrk-subscription-coaching').val();
      if (variantId) {
          var hiddenInputId = $('<input>').attr({
              type: 'hidden',
              name: `items[${index}][id]`,
              value: variantId
          });
          var hiddenSubscription = '';
          if(subscription != ''){
              hiddenSubscription = $('<input>').attr({
                  type: 'hidden',
                  name: `items[${index}][selling_plan]`,
                  value: subscription
              });
          }
          var hiddenInputQuantity = $('<input>').attr({
              type: 'hidden',
              name: `items[${index}][quantity]`,
              value: quantity
          });
          
          $('.mrk-hidden-inputs').append(hiddenInputId,hiddenInputQuantity,hiddenSubscription);
      }
    }
    function createHiddenInputs() {
        const main_container = $('.product-details');
        $('.mrk-hidden-inputs').html('');
        var variants = [];
        if($('.mrk-product-page-bundle').length){
          $('.custom-hidden-input').prop('disabled', true);
        }
        var index = 0;
        $('.quantity-break').each(function () {
            var inputItem = $(this).find('[name="mrk-quantity"]');
            if ($(inputItem).is(':checked')) {
                $(this).find('.quantity-break__selector-item').each(function () {
                    var variantId = $(this).attr('data-selected-id');
                    if (variantId) {
                        variants.push({id: variantId, quantity: 1});
                    }
                });
                $(this).find('[name="upsell-item"]:checked, .mrk-fixed-item').each(function(){
                  // AH: skip duplicate inputs inside hidden ah-free-item1 rows
                  if($(this).closest('.ah-free-item1').length) return;
                  var id = $(this).val(),
                  quantity = Number($(this).attr('quantity')) || 1,
                  parent_id = window.product_id,
                  subscription_id = $(this).attr('subscription');
                  if(subscription_id != ''){
                    variants.push({id: id, quantity: quantity, selling_plan: subscription_id, parent: parent_id});
                  }else{
                    variants.push({id: id, quantity: quantity, parent: parent_id});
                  }
                });
            }
        });
        
        $('.mrk-subscription-plan').find('[name="upsell-item"]:checked, .mrk-fixed-item').each(function(){
          // AH: skip duplicate inputs inside hidden ah-free-item1 rows
          if($(this).closest('.ah-free-item1').length) return;
          var id = $(this).val(),
          quantity = Number($(this).attr('quantity')) || 1,
          parent_id = window.product_id,
          subscription_id = $(this).attr('subscription');
          if(subscription_id != ''){
            variants.push({id: id, quantity: quantity, selling_plan: subscription_id, parent: parent_id});
          }else{
            variants.push({id: id, quantity: quantity, parent: parent_id});
          }
        });
        $.each(variants, function(index, variant) {
          var hiddenInputproperties = undefined;
          if (variant.id) {
            if(index == 0){
              // Create hidden input for variant id
              var hiddenInputId = $('<input>').attr({
                type: 'hidden',
                name: `id`,
                value: variant.id
              });
              var hiddenInputgroupCount = $('<input>').attr({
                type: 'hidden',
                name: `properties[_groupcount]`,
                value: Number($('[name="mrk-quantity"]:checked').val())/2
              });
              // Create hidden input for variant quantity
              var hiddenInputQuantity = $('<input>').attr({
                type: 'hidden',
                name: `quantity`,
                value: variant.quantity
              });
            }else{
              // Create hidden input for variant id
              var hiddenInputId = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][id]`,
                value: variant.id
              });
              var hiddenInputgroupCount = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][properties[_groupcount]]`,
                value: Number($('[name="mrk-quantity"]:checked').val())/2
              });
              // Create hidden input for variant quantity
              var hiddenInputQuantity = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][quantity]`,
                value: variant.quantity
              });
              if(variant.parent){
                hiddenInputproperties = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][properties[_parent_id]]`,
                value: variant.parent
              });
              }
            }
            
        
            $('.mrk-hidden-inputs').append(hiddenInputId, hiddenInputgroupCount, hiddenInputQuantity, hiddenInputproperties);
        
            // If there's a selling plan, add that too
            if (variant.selling_plan) {
              var hiddenInputSellingPlan = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][selling_plan]`,
                value: variant.selling_plan
              });
              $('.mrk-hidden-inputs').append(hiddenInputSellingPlan);
            }
          }
        });
        if($('[name="id"]').val() == variants[0].id && variants.length == 1){
          $('.shopify-payment-button').show()
        }else{
          $('.shopify-payment-button').hide()
        }
      
    }

    // AHPK product picker bridge: let the self-contained picker rebuild the cart
    // hidden inputs after it updates its own data-selected-id.
    window.mrkBuildBundleCart = createHiddenInputs;

    // Event listener for change on any select
    $('.mrk-bundles-option, .mrk-option-item').on('change', function () {
        window.selected_select = $(this).parents('.m-product-option').attr('mrk-id') || $(this).attr('mrk-id');
        updateVariantId();
        createHiddenInputs();
    });
    $('[name="mrk-quantity"],[name="selling-plan"],.mrk-addon-id').on('change', function () {
        updateVariantId();
        createHiddenInputs();
        $(this).parents('.mrk-bundles__bar')[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
    });
    // AH: gift checkbox — remove/restore input + visual state + rebuild cart
    $(document).on('change', '.ah-gift-check', function(){
        var row = $(this).closest('.ah-free-item2');
        if(this.checked){
          row.removeClass('ah-gift-removed');
          var stored = row.data('ah-removed-input');
          if(stored){
            row.prepend(stored);
            row.removeData('ah-removed-input');
          }
        } else {
          row.addClass('ah-gift-removed');
          var hidden = row.find('.mrk-fixed-item');
          if(hidden.length){
            row.data('ah-removed-input', hidden.detach());
          }
        }
        createHiddenInputs();
    });
    // Initial update on page load
    updateVariantId();
    createHiddenInputs();
    setTimeout(function(){
      document.querySelectorAll('.m-product-media--slider__images .swiper-container').forEach((slider) => {
        slider.swiper.slideTo(1);
      })
    },1000);
});